<fcom-notification
  *ngIf="showNotification"
  [isClosable]="true"
  [theme]="NotificationTheme.SUCCESS"
  (closeClick)="showNotification = false"
>
  {{ 'newsletterSubscribedNotification' | finLocalization }}
</fcom-notification>
